import axiosClient from 'utils/axiosClient';
import api from 'api';

const getIssuanceBooks = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.ISSUANCES.ISSUANCES, {params: data});
	return response.data;
};

const getOverdueIssuanceBooks = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.ISSUANCES.OVERDUE_ISSUANCES, {params: data});
	return response.data;
};

const returnBook = async (data: any) => {
	const response = await axiosClient.post(api.LIBRARY.ISSUANCES.RETURN_BOOK, data);
	return response.data;
};

const issueBook = async (data: any) => {
	const response = await axiosClient.post(api.LIBRARY.ISSUANCES.ISSUE_BOOK, data);
	return response.data;
};

const service = {
	getIssuanceBooks,
	getOverdueIssuanceBooks,
	returnBook,
	issueBook
};

export default service;
